module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "messages huge ico-notification pointer dark",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.toggleOpenClose.apply(null, arguments)
      }
    }
  }, [(_vm.unreadNotificationsNr > 0) ? _c('span', {
    staticClass: "number bold text-center lightest bg-brand",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.toggleOpenClose.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.unreadNotificationsNr > 9 ? '9+' : _vm.unreadNotificationsNr))]) : _vm._e(), _vm._v(" "), (_vm.getIsBellNotificationOpen) ? _c('div', {
    staticClass: "box cursor-default"
  }, [_c('div', {
    staticClass: "wrapper pb-0"
  }, [_c('h5', {
    staticClass: "d-flex mb-0 justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex flex-grow-1"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "mr-3 pointer normal color-1",
    on: {
      "click": _vm.markAllNotificationsRead
    }
  }, [_vm._v("Mark all as read")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-sync pointer",
    class: {
      'opacity-50 spin': _vm.getIsFetchingNotifications
    },
    on: {
      "click": _vm.reloadNotifications
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "list m-0",
    on: {
      "scroll": _vm.notificationsScoll
    }
  }, [_vm._l((_vm.notifications), function(item) {
    return (_vm.notifications.length > 0) ? _c('default-Notification', {
      key: item.id,
      staticClass: "border-bottom-medium",
      attrs: {
        "notification": item,
        "options": _vm.notificationOptions
      },
      on: {
        "click": function($event) {},
        "deleteNotification": function($event) {
          return _vm.deleteNotification($event)
        },
        "notificationClicked": function($event) {}
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "text-center p-3",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('loader')], 1) : _vm._e()], 2), _vm._v(" "), (!_vm.isLoading && _vm.notifications.length < 1) ? _c('div', {
    staticClass: "text-center pb-4 pt-2"
  }, [_c('p', [_vm._v("No notifications.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "options bg-faded border-top-light d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "pointer color-1",
    on: {
      "click": _vm.viewAll
    }
  }, [_vm._v("View all")])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4125b9ba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4125b9ba"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Notifications.vue
// module id = 2452
// module chunks = 0